(() => {
  const form = document.getElementById('SenlanContactFormV2');
  if (!form) return;

  const submit = form.querySelector('[data-contact-submit]');
  const submitLabel = form.querySelector('[data-contact-submit-label]');
  const addDescription = (field, id) => {
    const current = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (!current.includes(id)) field.setAttribute('aria-describedby', [...current, id].join(' '));
  };
  const removeDescription = (field, id) => {
    const current = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean).filter((item) => item !== id);
    if (current.length) field.setAttribute('aria-describedby', current.join(' '));
    else field.removeAttribute('aria-describedby');
  };
  const setClientError = (field) => {
    const wrapper = field.closest('[data-contact-field]');
    const error = wrapper?.querySelector('[data-contact-client-error]');
    if (!wrapper || !error) return;
    wrapper.classList.add('senlan-contact-v2__field--error');
    field.setAttribute('aria-invalid', 'true');
    error.textContent = field.validationMessage;
    error.hidden = false;
    addDescription(field, error.id);
  };
  const clearClientError = (field) => {
    const wrapper = field.closest('[data-contact-field]');
    const error = wrapper?.querySelector('[data-contact-client-error]');
    if (!wrapper || !error || field.validity.valid === false) return;
    error.textContent = '';
    error.hidden = true;
    removeDescription(field, error.id);
    if (!wrapper.querySelector('[data-contact-server-error]:not([hidden])')) {
      wrapper.classList.remove('senlan-contact-v2__field--error');
      field.removeAttribute('aria-invalid');
    }
  };
  const focusStatus = (selector) => {
    const status = form.querySelector(selector);
    if (!status) return;
    status.focus({ preventScroll: true });
    status.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  };

  form.addEventListener('invalid', (event) => setClientError(event.target), true);
  form.addEventListener('input', (event) => clearClientError(event.target));
  form.addEventListener('change', (event) => clearClientError(event.target));
  form.addEventListener('submit', (event) => {
    if (!form.checkValidity() || !submit || !submitLabel) return;
    // A document-level app listener cancels bubbled submits. Keep this native form local.
    event.stopPropagation();
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    const italianSending = form.closest('.senlan-contact-v2')?.dataset.contactSendingIt;
    submitLabel.textContent = italianSending || (document.documentElement.lang.toLowerCase().split('-')[0] === 'fr' ? "Envoi en cours…" : document.documentElement.lang.toLowerCase().split('-')[0] === 'es' ? "Enviando…" : (/^de(?:-|$)/i.test(document.documentElement.lang)
      ? 'Wird gesendet...'
      : 'Sending...'));
  });

  const growingHelp = form.closest('.senlan-contact-v2')?.querySelector('a[href="#contact-form"]');
  growingHelp?.addEventListener('click', (event) => {
    const topic = form.querySelector('#SenlanContactFormV2-topic');
    const message = form.querySelector('#SenlanContactFormV2-message');
    if (!topic || !message) return;
    event.preventDefault();
    topic.value = 'Growing question';
    form.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    message.focus({ preventScroll: true });
  });

  focusStatus('[data-contact-form-errors]');
  focusStatus('[data-contact-form-success]');
})();
